import { useFeatureFlag } from '@order/LaunchDarkly';

export const useShouldUseDecoupledCustomerLogin = () => {
  return useFeatureFlag('OPS-customer-decoupling-login-enabled');
};
